<script lang="tsx">
import { defineComponent, toRef, computed, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
import { genHouseDemolitionEntryDataSource } from '../../tools'
import { calcMulAmount, sumDecimalBy } from '../../calc'

const [name] = createNamespace('HouseDemolitionCompEntryForm')

export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtZch.CompData>>
    },
    standard: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>
    },
    prefix: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  setup(props, { expose }) {
    const genFormItemName = (key: string) => [...props.prefix, key]

    const data = toRef(props, 'dataSync', {})

    const dataSource = computed(() => genHouseDemolitionEntryDataSource(data.value))

    /** 单行金额：数量 * 标准 */
    const getRowTotal = (key: string) => calcMulAmount(data.value?.[key], props.standard?.[key])

    const totalAmount = computed(() => sumDecimalBy(dataSource.value, record => getRowTotal(record.key)))

    const columns: TableColumnType[] = [
      {
        title: '类别',
        dataIndex: 'type',
        width: 300,
        customRender({ text }) {
          return <span innerHTML={text}></span>
        }
      },
      {
        title: '单位',
        dataIndex: 'unit',
        width: 50,
        customRender() {
          return '平方米'
        }
      },
      {
        title: '标准(元/单位)',
        dataIndex: 'standard',
        width: 100,
        customRender({ record }) {
          return props.standard?.[record.key] ?? '-'
        }
      },
      {
        title: '数量',
        dataIndex: 'count',
        width: 50,
        customRender({ record }) {
          return (
            <FormItem name={genFormItemName(record.key)} rules={getRequiredRule(`${record.type}数量`)}>
              <InputRmb v-model:value={data.value![record.key]} style='width: 100%' />
            </FormItem>
          )
        }
      },
      {
        title: '金额(元)',
        dataIndex: 'total',
        width: 100,
        customRender({ record }) {
          return getRowTotal(record.key).toFixed(2)
        }
      }
    ]

    const renderFooter = () => {
      return <div class='ant-calc-table-footer'>小计金额：{totalAmount.value.toFixed(2)} 元</div>
    }

    expose({
      totalAmount
    })
    return () => (
      <Table pagination={false} columns={columns} dataSource={dataSource.value} size='small' footer={renderFooter} class='ant-calc-table' />
    )
  }
})
</script>
